module.exports = __webpack_public_path__ + "static/media/3DPPA2.26b470f0.jpg";